import { useState } from 'react';
import { t } from 'i18next';
import { useSpendInviteCode } from '../../../domains/user/ui/hooks/useSpendInviteCode';
import { useSuccessPhotoCardToast } from '../../template/edit-collected-photo-cards/hooks/useSuccessPhotoCardToast';
import { ReactComponent as GradientAttention } from '../../../icons/gradient.attention.svg';

export const useEnterRedeemCode = () => {
  const [inviteCode, setInviteCode] = useState('');
  const { mutateAsync: spendInviteCode } = useSpendInviteCode();
  const showSuccessToast = useSuccessPhotoCardToast();

  const handleChangeInviteCode = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInviteCode(e.target.value);
  };

  const handleSpendInviteCode = async () => {
    if (inviteCode.trim().length === 0) {
      return;
    }
    try {
      const response = await spendInviteCode(inviteCode);
      if (response.user) {
        showSuccessToast('bottom', t('EnterRedeemCode.successToastMessage') as string);
        setInviteCode('');
      }
    } catch (error) {
      if ((error as any).error.code === 'ALREADY_INVITED') {
        showSuccessToast(
          'bottom',
          t('EnterRedeemCode.alreadyInvited') as string,
          false,
          <GradientAttention width={20} height={20} />
        );
      } else if ((error as any).error.code === 'EXPIRED_USER') {
        showSuccessToast(
          'bottom',
          t('EnterRedeemCode.expiredUser') as string,
          false,
          <GradientAttention width={20} height={20} />
        );
      } else {
        showSuccessToast(
          'bottom',
          t('EnterRedeemCode.invalidCode') as string,
          false,
          <GradientAttention width={20} height={20} />
        );
      }
    }
  };

  return {
    inviteCode,
    handleChangeInviteCode,
    handleSpendInviteCode
  };
};
